import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@nexus/ui"
import { useTranslation } from "react-i18next"

interface SendVendorCloseConfirmProps {
  open: boolean
  onStay: () => void
  onClose: () => void
}

export function SendVendorCloseConfirm({ open, onStay, onClose }: SendVendorCloseConfirmProps) {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onStay() }}>
      <DialogContent
        onInteractOutside={(event) => event.preventDefault()}
        onEscapeKeyDown={onStay}
      >
        <DialogHeader>
          <DialogTitle>
            {t("marketplace.sendHandoff.closeConfirmTitle", "Close send to production partner?")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "marketplace.sendHandoff.closeConfirmBody",
              "Your draft stays on this device. You can reopen and continue.",
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" size="sm" onClick={onStay}>
            {t("marketplace.sendHandoff.closeConfirmStay", "Keep editing")}
          </Button>
          <Button type="button" size="sm" onClick={onClose}>
            {t("marketplace.sendHandoff.closeConfirmLeave", "Close anyway")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
